import { render, staticRenderFns } from "./CustomRadioButton.vue?vue&type=template&id=75c9d13c"
import script from "./CustomRadioButton.vue?vue&type=script&lang=js"
export * from "./CustomRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports